import { Grid, Typography } from "@mui/material";
import { usePriorityText } from "./styles";
import { Priority } from "../../../../../../../../utils/enums/priority";
import { useContextState } from "../../../../../../../../hooks/theme";

const PriorityText = (props: any) => {
  const styles = usePriorityText();
  const { colors } = useContextState()
  const priorityId = props?.row.priorityId; 
  const priorityName = props?.current;
  const getColor = (priorityId: number) => {
    const colorMap: Record<number, string> = {
      [Priority.URGENT] : colors.color28,
      [Priority.HIGH] : colors.secondary,
      [Priority.MEDIUM] : colors.color8, 
      [Priority.LOW] : colors.color10
    };
    return colorMap[priorityId] || colors.color10;
  };

  const getName = (priorityId: number) => {
    const colorMap: Record<number, string> = {
      [Priority.URGENT] : 'Urgente',
      [Priority.HIGH] : 'Alta',
      [Priority.MEDIUM] : 'Media', 
      [Priority.LOW] : 'Baja'
    };
    return colorMap[priorityId] || "";
  };

  return (
    <Grid container justifyContent="left" alignItems="center" columnSpacing={1}>
      <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
        <Typography
          sx={{
            ...styles.textItem,
            color: getColor(priorityId),
          }}
        >
          {getName(priorityId) || ""}
        </Typography>
      </Grid>
    </Grid>
  );
};

export { PriorityText };